"use client";

import { useEffect, useState } from "react";
import { EventsData } from "../../types";
import { categorizeEvents } from "../../utils/eventUtils";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PressSection from "@/components/PressSection";

export default function ArchivPage() {
  const [data, setData] = useState<EventsData | null>(null);

  useEffect(() => {
    fetch(`/api.php?action=get_events&t=${new Date().getTime()}`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  const past = data ? categorizeEvents(data.events).past : [];

  return (
    <main>
      <Navbar />
      <section className="section-block concert-dates min-h-screen pt-40 md:pt-48 px-5 text-center">
        <div className="container mx-auto px-4 pb-20">
          <PressSection />
        </div>

        <h2 id="archiv-liste">Archiv - Vergangene Gigs</h2>
        <div className="band-description mb-16 italic">
          Hier findet ihr eine Übersicht aller unserer vergangenen Auftritte. Jede Performance war ein besonderes Erlebnis und hat uns als Band weitergebracht. Vielen Dank an alle, die uns begleitet haben!
        </div>

        <div className="table-container shadow-xl rounded-xl overflow-hidden max-w-5xl mx-auto">
          <table className="w-full border-collapse bg-black/30 backdrop-blur-sm text-left responsive-table">
            <thead>
              <tr className="bg-primary text-accent uppercase tracking-wider font-oswald">
                <th className="p-5">Datum</th>
                <th className="p-5">Veranstaltung</th>
                <th className="p-5">Ort</th>
              </tr>
            </thead>
            <tbody>
              {data && past.length > 0 ? (
                past.map((event, index) => (
                  <tr key={index} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                    <td className="p-5" data-label="Datum">{event.date}</td>
                    <td className="p-5 font-bold" data-label="Veranstaltung">{event.event}</td>
                    <td className="p-5" data-label="Ort">{event.location}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="p-10 text-center italic">
                    {data ? "Keine vergangenen Auftritte vorhanden." : "Lade Archiv..."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
      <Footer />
    </main>
  );
}